exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".news-title{margin:1rem 0;padding:1rem;color:#fff;background:#292929;flex:100%;font-size:2.1rem}.news-title.news-subtitle{margin:1rem 0;font-size:1.6rem}.news-title.news-title--no-top{margin-top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-2fde53c1","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/news/news-heading.vue
// module id = 51
// module chunks = 4 5